module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"all":"All","button":"Add a image","title":"Images","type":"type","upload":"Upload"}}')
  delete Component.options._Ctor
}
